import { InteractionColors, InteractionIcons } from "./interaction-icon.contants";
import { unreachableCaseError } from "@edgetier/utilities";
import { faQuestion } from "@fortawesome/pro-solid-svg-icons";
import { InteractionType } from "@edgetier/watchtower-types";

/**
 * Get the icon applicable to the interaction being displayed.
 * @param interactionType The type of interaction.
 * @returns An icon relevant to the interaction.
 */
export const getInteractionIcon = (interactionType: InteractionType) => {
    let icon = InteractionIcons[interactionType];

    if (typeof icon === "undefined") {
        unreachableCaseError(interactionType as never);
        icon = faQuestion;
    }
    return icon;
};

export const getInteractionColor = (interactionType: InteractionType) => {
    let color = InteractionColors[interactionType];

    if (typeof color === "undefined") {
        unreachableCaseError(interactionType as never);
        color = "primary";
    }
    return color;
};
